import React from 'react'
import { useTranslation } from 'react-i18next'
import { settingTabsName } from 'utils/constant'
import CharacterSection from './CharacterSection'
import MeaningsSection from './MeaningsSection'
import WordAudioSection from './WordAudioSection'
import WordMasterySection from './WordMasterySection'
import DiscussionEmailSection from './DiscussionEmailSection'

/** Element id of a Reading section, so #character, #audio and #words can scroll to it. */
export const readingSectionId = (key: string) => `settings-${key}`

// Reply emails can reach learners outside the lesson-discussions rollout (someone replied to their
// answer), so the switch is always here for them to turn off.
const ReadingTab = () => {
  const { t } = useTranslation('settings')
  return (
    <>
      <h4 className='m-h4 m-gray-1'>{t('pages.reading')}</h4>
      <CharacterSection id={readingSectionId(settingTabsName.character)} />
      <MeaningsSection id={readingSectionId('meanings')} />
      <WordAudioSection id={readingSectionId(settingTabsName.audio)} />
      <WordMasterySection id={readingSectionId(settingTabsName.words)} />
      <DiscussionEmailSection id={readingSectionId(settingTabsName.discussion)} />
    </>
  )
}

export default ReadingTab
